import { z } from "zod";
export const ticketSurveyStatusSchema = z.enum([
    "NOT_SELECTED",
    "SELECTED",
    "PROCESSING",
    "RESOLUTION_SENT",
    "RESOLVED_CONFIRMED",
    "NOT_RESOLVED",
    "CSAT_SENT",
    "CSAT_ANSWERED",
    "EXPIRED",
    "INVALIDATED",
    "CANCELLED"
]);
const idList = z.array(z.string().trim().min(1).max(160)).max(500);
const queryIdList = z.preprocess((value) => typeof value === "string" ? value.split(",").filter(Boolean) : value, idList.default([]));
export const ticketSurveySettingsSchema = z.object({
    enabled: z.boolean(),
    samplePercentage: z.number().int().min(0).max(100),
    cooldownHours: z.number().int().min(0).max(8760),
    expirationHours: z.number().int().min(1).max(720),
    sendDelaySeconds: z.number().int().min(15).max(300),
    eligibleQueueIds: idList,
    eligibleTagIds: idList,
    excludedCompanyIds: idList,
    excludedContactIds: idList,
    commentScoreMax: z.number().int().min(1).max(5),
    maxClosureAttempts: z.number().int().min(1).max(10),
    minTicketDurationMinutes: z.number().int().min(0).max(1440),
    minCustomerMessages: z.number().int().min(0).max(100),
    minAgentMessages: z.number().int().min(0).max(100),
    minTechnicianSample: z.number().int().min(1).max(1000)
});
export const invalidateTicketSurveySchema = z.object({
    reason: z.string().trim().min(10).max(1000),
    expectedVersion: z.number().int().nonnegative()
});
export const ticketSurveyAnalyticsQuerySchema = z.object({
    range: z.enum(["24h", "7d", "30d", "12w", "12m", "custom"]).default("30d"),
    from: z.string().date().optional(),
    to: z.string().date().optional(),
    queueIds: queryIdList,
    technicianIds: queryIdList,
    companyIds: queryIdList,
    tagIds: queryIdList
}).superRefine((value, context) => {
    if (value.range !== "custom")
        return;
    if (!value.from || !value.to || value.from > value.to) {
        context.addIssue({
            code: "custom",
            path: ["to"],
            message: "Informe um período válido"
        });
    }
});
